export default [
  {
    path: "manage-company",
    meta: {
      title: "companiesDashboard",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/ManageCompany",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "company-list",
    name: "company-list",
    meta: {
      title: "manageCompany",
    },
    component: () => import("@/views/pages/Administration/ManageCompany.vue"),
  },
  {
    path: "manage-license",
    meta: {
      title: "manageLicence",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/ManageLicense",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "install-package",
    meta: {
      title: "installPackage",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/MultiTenant/Administrator/InstallPackageList",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "add-publisher",
    meta: {
      title: "addPublisher",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/CompanyPublisher",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "global-role-policies",
    meta: {
      title: "globaRolePolicies",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/GlobalRolePolicy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "company-overview",
    meta: {
      title: "companyManagement",
      target: process.env.VUE_APP_AGMS_URL + "/AppGuard/SiteList",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "site-overview",
    meta: {
      title: "siteOverview",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/AppGuardMain/Site?$paramsByRole`,
      needMainId: true,
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "manage-dashboard",
    meta: {
      title: "manageDashboard",
      target: process.env.VUE_APP_AGMS_URL + "/Home/MainDashboard",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "agent-task",
    meta: {
      title: "agentTask",
      target: process.env.VUE_APP_AGMS_URL + "/Computers/Computers/TaskList",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "agent-settings",
    meta: {
      title: "agentSettings",
      target: process.env.VUE_APP_AGMS_URL + "/Administration/Administrator/AgentSettings",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "audit-viewer",
    meta: {
      title: "auditViewer",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/AuditViewer",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "company-audit-viewer",
    meta: {
      title: "auditViewer",
      target: process.env.VUE_APP_AGMS_URL + "/AuditViewer/AuditViewer",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "user-activity",
    meta: {
      title: "userActivity",
      target: process.env.VUE_APP_AGMS_URL + "/AuditViewer/AuditViewer",
    },
    component: () => import("@/views/pages/Administration/AuditViewer.vue"),
  },
  {
    path: "role-policy-list",
    meta: {
      title: "rolePolicyList",
      target: process.env.VUE_APP_AGMS_URL + "/AppGuard/TemplateList",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  // {
  //   path: "pdpsandlrps",
  //   meta: {
  //     title: "pdpsLrps",
  //     target:
  //       process.env.VUE_APP_AGMS_URL +
  //       `/Server/Server/ServerList?$paramsByRole`,
  //   },
  //   component: () => import("@/views/pages/Iframe.vue"),
  // },
  {
    path: "networks",
    meta: {
      title: "networks",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Network/Network/NetworkList?$paramsByRole`,
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "scripts",
    meta: {
      title: "scripts",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Administration/Administrator/ScriptList",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "group-list",
    meta: {
      title: "groupList",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/AppGuardMain/Site/GroupList?mainId=$siteParamsMainId&type=Site`,
      needMainId: true,
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "group-dashboard",
    meta: {
      title: "groupDashBoard",
      target:
        process.env.VUE_APP_AGMS_URL + `/AppGuardMain/Group/?$paramsByRole`,
      needMainId: true,
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "users",
    component: () => import("@/views/pages/Users.vue"),
    meta: {
      title: "manageUsers",
      //target: process.env.VUE_APP_AGMS_URL + "/Administration/User/UserList",
    },
  },
  {
    path: "manage-partners",
    component: () => import("@/views/pages/Partners.vue"),
    meta: {
      title: "managePartners",
    },
  },
  {
    path: "app-group-management",
    name:"AppGroupManagement",
    component: () => import("@/views/pages/AppGroup/AppGroupManagement.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "app-group-management-role",
    name: "templateAppGroupManagement",
    meta: {
      title: "",
    },
    component: () => import("@/views/pages/AppGroup/AppGroupManagement.vue"),
  },
  {
    path: "app-group-management/detail",
    name:"appGroupDetail",
    component: () => import("@/views/pages/AppGroup/AppGroupDetail.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "app-group-management/detail-role",
    name:"templateAppGroupDetail",
    component: () => import("@/views/pages/AppGroup/AppGroupDetail.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "global-policy-management",
    name: "globalPolicyManagement",
    component: () => import("@/views/pages/GlobalPolicy/GlobalPolicy.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "global-policy-management-role",
    name: "templateGlobalPolicy",
    meta: {
      title: "",
    },
    component: () => import("@/views/pages/GlobalPolicy/GlobalPolicy.vue"),
  },
  {
    path: "file-types-policy",
    name: "fileTypesPolicy",
    component: () => import("@/views/pages/FileTypesPolicy/FileTypesPolicy.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "file-types-policy-role",
    name: "templateFileTypesPolicy",
    meta: {
      title: "",
    },
    component: () => import("@/views/pages/FileTypesPolicy/FileTypesPolicy.vue"),
  },
  // Policy routes
  {
    path: "policy-management",
    meta: {
      title: "policyManagement",
      target:
        process.env.VUE_APP_AGMS_URL + `/AppGuardMain/Group?$paramsByRole`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "policy-management/group",
    meta: {
      title: "policyManagementGroup",
      target:
        process.env.VUE_APP_AGMS_URL + `/AppGuardMain/Group?$paramsByRole`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "default-enclave",
    meta: {
      title: "defaultEnclave",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/Spaces?$paramsByRole&policytypeId=10`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "trusted-publishers",
    meta: {
      title: "trustedPublishers",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/Policy/PolicyList?$paramsByRole&policytypeId=4`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "power-apps",
    meta: {
      title: "powerApps",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/PowerApps?$paramsByRole&policytypeId=3`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "trusted-folders",
    meta: {
      title: "trustedFolders",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/TrustedFolders?$paramsByRole&policytypeId=14`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "global-policy",
    meta: {
      title: "globalPolicy",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/GlobalPolicy?$paramsByRole&policytypeId=12`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "code-load",
    meta: {
      title: "codeLoad",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/CodeLoad?$paramsByRole&policytypeId=13`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "netlock-policy",
    meta: {
      title: "netlockPolicy",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/NetLockPolicy?$paramsByRole&policytypeId=15`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "trusted-enclave",
    meta: {
      title: "trustedEnclave",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/Policy/PolicyList?$paramsByRole&policytypeId=7`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "removable-media",
    name: "removableMedia",
    meta: {
      title: "",
    },
    component: () => import("@/views/pages/RemovableMedia/RemovableMedia.vue"),
  },
  {
    path: "removable-media-role",
    name: "templateRemovableMedia",
    meta: {
      title: "",
    },
    component: () => import("@/views/pages/RemovableMedia/RemovableMedia.vue"),
  },
  {
    path: "custom-scripts",
    meta: {
      title: "customScripts",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/Policy/PolicyList?$paramsByRole&policytypeId=8`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "publishers",
    meta: {
      title: "publishers",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Computers/Computers/LogPublishers`,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "space-rule",
    meta: {
      title: "spaceRule",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/Policy/PolicyList?$paramsByRole&policytypeId=9",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "ignore-message",
    meta: {
      title: "ignoreMessage",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/Policy/PolicyList?$paramsByRole&policytypeId=1",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  // {
  //   path: "ignore-events",
  //   meta: {
  //     title: "ignoreEvents",
  //     target:
  //       process.env.VUE_APP_AGMS_URL +
  //       "/Policy/GroupPolicy/IgnoreEventsFilter?$paramsByRole&policytypeId=19",
  //     parent: "policy",
  //   },
  //   component: () => import("@/views/pages/Iframe.vue"),
  // },
  {
    path: "ignore-events",
    name: "policyIgnoreEvents",
    component: () => import("@/views/pages/Administration/IgnoreEvents.vue"),
    meta: {
      title: "ignoreEvents",
    },
  },
  {
    path: "severity-events",
    name: "severityEvents",
    component: () => import("@/views/pages/Administration/EventSeverity.vue"),
    meta: {
      title: "severityEvents",
    },
  },
  // {
  //   path: "severity-events",
  //   meta: {
  //     title: "severityEvents",
  //     target:
  //       process.env.VUE_APP_AGMS_URL +
  //       "/Policy/GroupPolicy/SeverityEventsFilter?$paramsByRole&policytypeId=20",
  //     parent: "policy",
  //   },
  //   component: () => import("@/views/pages/Iframe.vue"),
  // },
  
  {
    path: "ignore-events-role",
    name: "templateIgnoreEvents",
    meta: {
      title: "ignoreEvents",
    },
    component: () => import("@/views/pages/Administration/IgnoreEvents.vue"),
  },
  {
    path: "severity-events-role",
    name: "templateSeverityEvents",
    meta: {
      title: "severityEvents",
    },
    component: () => import("@/views/pages/Administration/EventSeverity.vue"),
  },
  // {
  //   path: "severity-events-role",
  //   meta: {
  //     title: "severityEvents",
  //     target:
  //       process.env.VUE_APP_AGMS_URL +
  //       "/Policy/TemplatePolicy/SeverityEventsFilter?$paramsByRole&policytypeId=20",
  //     parent: "policy",
  //   },
  //   component: () => import("@/views/pages/Iframe.vue"),
  // },
  {
    path: "file-extensions",
    meta: {
      title: "fileExtensions",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/Policy/PolicyList?$paramsByRole&policytypeId=17",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "agent-alerts",
    meta: {
      title: "agentAlerts",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/$policySubmenu/AgentAlerts?$paramsByRole&policytypeId=17",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "summary-events",
    name: "summaryEvents",
    meta: {
      title: "",
    },
    component: () => import("@/views/pages/SummaryEvents/SummaryEventsList.vue"),
  },
  {
    path: "summary-events-role",
    name: "templateSummaryEvents",
    meta: {
      title: "",
    },
    component: () => import("@/views/pages/SummaryEvents/SummaryEventsList.vue"),
  },
  {
    path: "publishers",
    meta: {
      title: "publishers",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Computers/Computers/LogPublishers",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },

  // Policy
  {
    path: "policy-overview",
    meta: {
      title: "policyOverview",
    },
    component: () => import("@/views/pages/PolicyReview.vue"),
  },
  {
    path: "policy-review",
    name: "policyReview",
    meta: {
      title: "policyReview",
    },
    component: () => import("@/views/pages/BlocksRequiringReview.vue"),
  },
  {
    path: "policy-review/drafted",
    component: () => import("@/views/pages/policyReviewChecklist.vue"),
    meta: {
      title: "policyReview",
    },
  },
  {
    path: "policy-review/applied",
    component: () => import("@/views/pages/policyReviewChecklist.vue"),
    meta: {
      title: "policyReview",
    },
  },
  {
    path: "policy-review/published",
    component: () => import("@/views/pages/policyReviewChecklist.vue"),
    meta: {
      title: "policyReview",
    },
  },
  {
    path: "policy-review/keep-enforcing",
    component: () => import("@/views/pages/policyReviewChecklist.vue"),
    meta: {
      title: "policyReview",
    },
  },

  {
    path: "policy-compare",
    component: () => import("@/views/pages/Settings/CompareXML.vue"),
    meta: {
      title: "Policy Compare",
    },
  },
  {
    path: "policy-tuning",
    meta: {
      title: "groupDashboard",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/AppGuardMain/Group/?$paramsByRole`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
];
